import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { authState } from '@angular/fire/auth';
import { map, take } from 'rxjs/operators';

export const loginGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const auth: Auth = inject(Auth);

  return authState(auth).pipe(
    take(1),
    map((user) => {
      if (user) {
        // Si el usuario está autenticado, redirigir al dashboard
        router.navigate(['/dashboard']);
        return false;
      }
      // Si no está autenticado, permitir acceso a login
      return true;
    })
  );
};